import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { PlayCircleOutline, VideocamOutlined } from '@material-ui/icons';
import { VideoStatus, getVideoSite } from '@pvplevelup/core/dist/interfaces/IVideo';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: theme.spacing(2),
    borderRadius: 10,
    background: 'rgba(20, 20, 20, 0.92)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    overflow: 'hidden',
  },
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr)',
    gridColumnGap: 10,
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid rgba(255, 255, 255, 0.07)',
    fontWeight: 800,
    '& .MuiSvgIcon-root': { color: '#42a5f5' },
  },
  body: {
    display: 'grid',
    gridRowGap: 10,
    padding: theme.spacing(1.5, 2),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    gridColumnGap: 12,
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    background: 'rgba(255, 255, 255, 0.04)',
  },
  who: {
    fontWeight: 700,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  meta: {
    marginTop: 2,
    fontSize: '0.78rem',
    color: 'rgba(255, 255, 255, 0.6)',
  },
  button: {
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: 8,
  },
}));

export interface IVideoEntry {
  user?: {_id: string, displayname?: string} | null;
  /** the character's name in the record */
  name?: string | null;
  video?: {url: string, status?: VideoStatus | string | null} | null;
}

/** The approved videos players linked on a game, duel or PvE run (added and approved in the app). */
export const RecordVideos: React.FC<{entries: IVideoEntry[]}> = ({entries}) => {
  const classes = useStyles();
  const approved = entries.filter((entry) => entry.video && entry.video.url && entry.video.status == VideoStatus.Approved && getVideoSite(entry.video.url));
  if(approved.length == 0)
    return null;
  return (
    <div className={`${classes.card} game-videos`}>
      <div className={classes.header}><VideocamOutlined /><span>Videos</span></div>
      <div className={classes.body}>
        {approved.map((entry) => (
          <div key={entry.user?._id || entry.video!.url} className={classes.row}>
            <div style={{minWidth: 0}}>
              <div className={classes.who}>{entry.name || entry.user?.displayname || 'Player'}</div>
              <div className={classes.meta}>{getVideoSite(entry.video!.url)!.name}</div>
            </div>
            <Button size="small" variant="outlined" className={classes.button} startIcon={<PlayCircleOutline />}
              href={entry.video!.url} target="_blank" rel="noopener noreferrer">Watch</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
